import { hasErrorRule, isRequiredRule } from '../../Validation/rules';
export const comboBoxRuleSet = [hasErrorRule, isRequiredRule];